import React, { useState } from 'react';
import './CategoryPage.css';
import EmailSetupModal from './EmailSetupModal';

function SetupCategory({ onNavigate, onClose }) {
  const [showEmailSetup, setShowEmailSetup] = useState(false);

  return (
    <div className="category-page-container">
      <div className="category-page-header">
        <button onClick={onClose} className="back-button">
          ← Back to Dashboard
        </button>
        <div className="category-page-title">
          <span className="category-page-icon">⚙️</span>
          <h1>Setup & Configuration</h1>
        </div>
      </div>

      <div className="category-page-content">
        <div className="action-grid">
          <button className="action-card card-purple" onClick={() => onNavigate('franchiseeInformation')}>
            <span className="action-icon">📝</span>
            <span className="action-text">Your Information</span>
          </button>

          <button className="action-card card-gray" onClick={() => onNavigate('termStructureSetup')}>
            <span className="action-icon">⚙️</span>
            <span className="action-text">Term Structure Setup</span>
          </button>

          <button className="action-card card-purple" onClick={() => onNavigate('holidayManagement')}>
            <span className="action-icon">🗓️</span>
            <span className="action-text">Holiday Management</span>
          </button>

          <button className="action-card card-blue" onClick={() => onNavigate('lessonCalendar')}>
            <span className="action-icon">📅</span>
            <span className="action-text">Lesson Calendar</span>
          </button>

          <button className="action-card card-green" onClick={() => onNavigate('orderForm')}>
            <span className="action-icon">📦</span>
            <span className="action-text">Order Marketing Materials</span>
          </button>

          <button className="action-card card-blue" onClick={() => onNavigate('history')}>
            <span className="action-icon">📋</span>
            <span className="action-text">View Marketing Material Order History</span>
          </button>

          {/* 🆕 NEW EMAIL CONFIGURATION BUTTON */}
          <button className="action-card card-indigo" onClick={() => setShowEmailSetup(true)}>
            <span className="action-icon">📧</span>
            <span className="action-text">Email Configuration</span>
          </button>

        
        </div>
      </div>

      {/* Email Setup Modal */}
      {showEmailSetup && (
        <EmailSetupModal 
          onClose={() => setShowEmailSetup(false)}
          onSave={() => {
            console.log('Email settings saved');
          }}
        />
      )}
    </div>
  );
}

export default SetupCategory;